import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import ExchangeNft from '../../components/Gamification/ExchangeNft'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

const AutoRowColumn = styled(RowColumn)`
  height: 543px;
`

const Info = styled.div`
  color: ${({ theme }) => theme.bsText7};
  width: 432px;
  height: auto;
  flex: 1;
  margin-top: 25px;
  overflow-y: scroll;
  padding: 16px 30px;
  border-radius: 20px;
  background: ${({ theme }) => theme.bsBg2};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  `};
`



export default function GameAce () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/gameace.png'}/>
        <AutoRowColumn>
          <ExchangeNft type={NFTTYPE.GAMEACE} />
          <Info className={location.pathname.indexOf('gamification/car') > -1 ? activeClassName : ''}>
            <Text fontSize={14}>GameAce: World’s first NFTs that you can PLAY as standalone retro video games!</Text>
            <br/>
            <Text fontSize={14}>"Doggies Moon Chase":</Text>
            <Text fontSize={14}>The first game "Doggies Moon Chase" is a flappy-bird clone - a collaboration with CryptoDoggies. It is playable only with a valid cartridge NFT in your wallet. Only 999 NFTs of the first game exist.</Text>
            <br/>
            <Text fontSize={14}>Unique NFTs:</Text>
            <Text fontSize={14}>Even within the same game, every NFT offers a slightly different game experience ! Some cartridges have more unique feature combinations than others and could thus be more "valuable". You can check the rarity table on the game’s website.</Text>
            <br/>
            <Text fontSize={14}>Historic Milestone:</Text>
            <Text fontSize={14}>These NFTs are first of their kind and we see them as an historic milestone in the crypto-space. A unique opportunity to get a piece of NFT history. More games will follow soon!</Text>
            <br/>
            <Text fontSize={14}>Yours to enjoy:</Text>
            <Text fontSize={14}>Play on desktop or mobile, use the input devices that you want: Gamepad, Touch, Keyboard, Mouse...</Text>
            <br/>
            <Text fontSize={14}>Deployed on IPFS: fully autonomous, distributed, unmodifiable, indestructible, forever yours.</Text>
          </Info>
        </AutoRowColumn>
      </Main>
    </SoccerMain>
  )
}